<script setup lang="ts">
import { Menu } from 'lucide-vue-next';

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';
import { onMounted, ref, toRefs } from 'vue';
import { cn } from '@/lib/utils';

export type NavItem = {
    name: string;
    href: string;
}

const currentPath = ref<string>();

const props = defineProps<{
    navs: NavItem[],
    type: "normal" | "burger",
    class?: string
}>();

const propRefs = toRefs(props);
const classRef = propRefs.class;

function addTrailingSlash(url: string) {
    return url.endsWith('/') ? url : url + '/';
}

const processedNavs = props.navs.map((nav) => {
    return {
        name: nav.name,
        href: addTrailingSlash(nav.href),
    }
});

onMounted(() => {
    currentPath.value = addTrailingSlash(window.location.pathname);
})

</script>

<template>
    <div v-if="type == 'normal'" :class="class">
        <nav class="tw-flex tw-flex-row tw-gap-6">
            <a v-for="nav in processedNavs" :key="nav.name" :href="nav.href" class="nav_item"
                :style="currentPath == nav.href ? 'color: hsl(var(--highlight-foreground))' : ''">
                {{ nav.name }}
            </a>
        </nav>
    </div>

    <div v-else-if="type == 'burger'" :class="['tw-h-full tw-aspect-square', classRef]">
        <DropdownMenu>
            <DropdownMenuTrigger class="tw-w-fit tw-h-full tw-px-4" as-child>
                <button title="navigation menu">
                    <Menu />
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent :side-offset=10 align="end" side="bottom" class="tw-p-4">
                <nav class="tw-flex tw-flex-col tw-gap-2">
                    <a v-for="nav in processedNavs" :key="nav.name" :href="nav.href" class="nav_item"
                        :style="currentPath == nav.href ? 'color: hsl(var(--highlight-foreground))' : ''">
                        {{ nav.name }}
                    </a>
                </nav>
            </DropdownMenuContent>
        </DropdownMenu>
    </div>
</template>

<style scoped>
.nav_item {
    font-family: 'Segoe UI', sans-serif;
    font-size: 1.25rem;
    transition: color 0.25s, border-bottom 0.4s;

    border-bottom: 2px solid rgba(0, 255, 255, 0);
    user-select: none;
}

.nav_item:hover {
    color: hsl(var(--highlight));

    border-bottom: 2px solid hsl(var(--highlight));
    cursor: pointer;
}
</style>